<template>
  <div>
    <div class="paymemt-container div-layout">
      <module-title title="打款管理" />
      <el-form class="searchForm" :inline="true" label-position="right" label-width="100px">
        <el-form-item label="推广者ID：" prop="spreadCode">
          <el-input v-model="searchForm.spreadCode" name="spreadCode" placeholder="请输入推广者ID" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="姓名：" prop="spreaderName">
          <el-input v-model="searchForm.spreaderName" name="spreaderName" placeholder="请输入姓名" class="handle-form-input" />
        </el-form-item>
        <el-form-item label="身份类别：" prop="agentGrade">
          <el-select v-model="searchForm.agentGrade" name="agentGrade" size="medium" class="edit-form-input">
            <el-option label="全部" value="" />
            <el-option v-for="(item,index) in leaveList" :key="index" :label="item.name" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="账号类型：" prop="spreadType">
          <el-select v-model="searchForm.spreadType" name="spreadType" size="medium" class="edit-form-input">
            <el-option label="全部" value="" />
            <el-option label="个人" value="1" />
            <el-option label="学校" value="2" />
            <el-option label="代理商" value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="手机号：" prop="phoneNumber">
          <el-input v-model="searchForm.phoneNumber" oninput="value=value.replace(/[^\d]/g,'')" name="phoneNumber" maxlength="11" placeholder="请输入手机号" class="handle-form-input" @change="changeNumber" />
        </el-form-item>
        <el-form-item label="状态：" prop="paymentStatus">
          <el-select v-model="searchForm.paymentStatus" name="paymentStatus" size="medium" class="edit-form-input">
            <el-option label="全部" value="" />
            <el-option label="未打款" value="1" />
            <el-option label="已打款" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请时间：" prop="time">
          <el-date-picker v-model="time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="datePickerOptions" :clearable="false" />
        </el-form-item>
        <el-form-item style="margin-left:15px;">
          <el-button type="primary" size="medium" icon="el-icon-search" @click="handleSearchFilter">
            查询
          </el-button>
          <el-button type="primary" size="medium" icon="el-icon-download" @click="handleExportFilter">
            导出
          </el-button>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <el-table v-loading="listLoading" border :data="settlementsList" highlight-current-row fit element-loading-text="Loading" class="list-table">
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="推广者ID" prop="spreadCode" align="center" width="120" />
          <el-table-column label="姓名" prop="name" align="center" />
          <el-table-column label="手机号" prop="phoneNumber" align="center" />
          <el-table-column label="账号类型" width="130" prop="spreadType" align="center">
            <template slot-scope="scope">
              {{ scope.row.spreadType === 1 ? '个人':'学校' }}
            </template>
          </el-table-column>
          <el-table-column label="用户身份" width="130" prop="agentGradeName" align="center" />
          <el-table-column label="银行" width="130" prop="bankCode" align="center" />
          <el-table-column label="银行卡号" width="130" prop="bankCardNumber" align="center" />
          <el-table-column label="开户支行" width="130" prop="bankBranchName" align="center" />
          <el-table-column label="申请结算佣金（元）" width="200" prop="appliedSettlementAmount" align="center" />
          <el-table-column label="可结算佣金（元）" width="200" prop="actualSettlementAmount" align="center" />
          <el-table-column label="申请时间" width="160" prop="appliedSettlementDatetime" align="center" />
          <el-table-column label="状态" width="130" prop="paymentStatus" align="center">
            <template slot-scope="scop">
              {{ scop.row.paymentStatus===1?'未打款':'已打款' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="250">
            <template slot-scope="scop">
              <el-button v-if="scop.row.paymentStatus==2" type="primary" size="small" @click="openPaymentRecord('record',scop.row)">
                打款记录
              </el-button>
              <el-button v-if="scop.row.paymentStatus==1" type="primary" size="small" icon="el-icon-edit" @click="openPaymentRecord('label',scop.row)">
                标记打款
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="page.total"
          :page.sync="page.pageNum"
          :limit.sync="page.pageSize"
          @pagination="pageCurriculumList"
          @handleSizeChange="handleSizeChange"
        />
      </div>
    </div>
    <el-dialog v-if="dialogPaymentVisible" :close-on-click-modal="false" :visible.sync="dialogPaymentVisible" width="700px" title="标记打款" @close="closeDialog">
      <div class="info-box">
        <el-row :span="10">
          <el-col>推广者ID：{{ rowDetail.spreadCode }}</el-col>
          <el-col>用户身份：{{ rowDetail.spreadType ==1 ?'个人':'学校' }}</el-col>
          <el-col>可结算佣金（元）：{{ rowDetail.settleableCommissionAmount }}</el-col>
        </el-row>
        <el-row :span="10">
          <el-col>姓名：{{ rowDetail.name }}</el-col>
          <el-col>手机号：{{ rowDetail.phoneNumber }}</el-col>
          <el-col>待结算佣金（元）：{{ rowDetail.unsettleableCommissionAmount }}</el-col>
        </el-row>
      </div>
      <el-form ref="paymentForm" label-position="right" label-width="120px" :model="paymentForm" :rules="paymentFormRules">
        <el-form-item label="结算佣金：" prop="actualSettlementAmount">
          <el-input v-model="paymentForm.actualSettlementAmount" name="actualSettlementAmount" class="payment-form-input" /> 元
        </el-form-item>
        <div class="up-box">
          <el-form-item label="打款凭证：" prop="upload">
            <div class="handle-form-input">
              <div v-if="paymentForm.paymentPictureUrlSet.length<9">
                <upload-file
                  ref="uploadFile"
                  :multiple-img="true"
                  :limit-img="9"
                  :props="{
                    serveCode: 'commission_payment_img',
                    accept: '.png, .jpg, .jpeg',
                    type: ['image/jpeg', 'image/jpg', 'image/png'],
                  }"
                  @uploadSucess="uploadSucessFn"
                >
                  <div class="up_btns">
                    <el-button style="margin-right:10px">
                      上传图片
                    </el-button>
                    <span>图片支持PNG/JPG格式，不超过{{ paymentForm.paymentPictureUrlSet.length }}/9张</span>
                  </div>
                </upload-file>
              </div>
              <div v-else>
                <el-button style="margin-right:10px" :disabled="true">
                  上传图片
                </el-button>
                <span>图片支持PNG/JPG格式，不超过{{ paymentForm.paymentPictureUrlSet.length }}/9张</span>
              </div>
            </div>
            <div class="picture-wrapper">
              <span v-if="paymentForm.paymentPictureUrlSet.length < 1" />
              <div v-for="(item,index) in paymentForm.paymentPictureUrlSet" v-else :key="index" class="img-item">
                <img class="img" :src="item">
                <span class="close-img" @click="removeImg(index)">X</span>
              </div>
            </div>
          </el-form-item>
        </div>

        <el-form-item label="备注：" prop="paymentRemark">
          <el-input v-model="paymentForm.paymentRemark" type="textarea" :rows="8" placeholder="请输入内容" maxlength="300" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeDialog">
          取消
        </el-button>
        <el-button type="primary" size="medium" :loading="ajaxLoading" @click="handlePayment">
          {{ ajaxLoading ? "Loading" : "确认" }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog v-if="dialogRecordVisible" :close-on-click-modal="false" :visible.sync="dialogRecordVisible" width="700px" title="打款记录">
      <div class="detail-box">
        <div class="line-box">
          <div>打款时间：{{ rowDetail.paymentDatetime }}</div>
          <div>申请结算佣金（元）：{{ rowDetail.appliedSettlementAmount }}</div>
        </div>
        <el-row>
          <el-col><span>已结算佣金（元）：{{ rowDetail.actualSettlementAmount }}</span></el-col>
          <el-col class="voucher-box">
            <span>打款凭证：</span>
            <el-row class="imgBoxView">
              <el-image v-for="(item,index) in rowDetail.paymentPictureUrlSet" :key="index" :src="item" :preview-src-list="rowDetail.paymentPictureUrlSet" style="width: 140px; height: 75px;margin-right:20px;" fit="cover" />
            </el-row>
          </el-col>
          <el-col class="line-box">
            <span>结算订单号：</span>
            <div class="itemMarig">
              <span v-for="(item,index) in rowDetail.orderCodes" :key="index"><span v-if="index!=0">，</span>{{ item }}</span>
            </div>
          </el-col>
          <el-col><span>备注：</span>{{ rowDetail.paymentRemark }}</el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getCommissionSettlementsList, getCommissionSettlementsDetail, markPayment, exportCommissionSettlementsExcel } from '@/api/yzdPlatformManage/promoterManage';
import { agentLevelMixin } from '../minxins/agentLevel';
export default {
  mixins: [agentLevelMixin],
  data() {
    return {
      time: '',
      searchForm: {
        spreadCode: '', // 推广者ID
        spreaderName: '', // 姓名
        agentGrade: '', // 身份类别
        spreadType: '', // 账号类型
        phoneNumber: '', // 手机号
        paymentStatus: '', // 状态
        startTime: '', // 开始时间
        endTime: '' // 结束时间
      },
      page: { // 分页参数
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      listLoading: false, // 表格刷新loading
      dialogPaymentVisible: false,
      paymentForm: {
        id: '',
        actualSettlementAmount: '', // 结算金额
        paymentPictureUrlSet: [], // 打款凭证
        paymentRemark: '', // 备注
        status: 1
      },
      uploadImgUrl: '',
      ajaxLoading: false,
      dialogRecordVisible: false,
      settlementsList: [],
      rowDetail: {},
      paymentFormRules: {
        actualSettlementAmount: [
          { required: true, message: '结算金额不能为空', trigger: 'blur' }
        ]
      },
      datePickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.searchForm.startTime = minDate.getTime();
          if (maxDate) {
            this.searchForm.startTime = '';
          }
        },
        disabledDate: (time) => {
          const one = 3 * 30 * 24 * 3600 * 1000;
          const minTime = this.startDate;
          if (this.searchForm.startTime !== '') {
            let maxTime = this.searchForm.startTime + one;
            if (maxTime > new Date()) {
              maxTime = new Date();
            }
            return time.getTime() > maxTime || time.getTime() < minTime || time.getTime() > Date.now() - 8.64e6;
          } else {
            return time.getTime() > Date.now() - 8.64e6;
          }
        }
      },
      option: {}
    };
  },
  mounted() {
    this.getTableList();
  },
  methods: {
    changeNumber(val) {
      this.searchForm.phoneNumber = val;
    },
    handleSearchFilter() {
      this.page.pageNum = 1;
      this.page.pageSize = 10;
      this.option = {
        spreadCode: this.searchForm.spreadCode, // 推广者ID
        spreaderName: this.searchForm.spreaderName, // 姓名
        agentGrade: this.searchForm.agentGrade, // 身份类别
        spreadType: this.searchForm.spreadType, // 账号类型
        phoneNumber: this.searchForm.phoneNumber, // 手机号
        paymentStatus: this.searchForm.paymentStatus, // 状态
        startTime: this.time[0], // 开始时间
        endTime: this.time[1] // 结束时间
      };
      this.getTableList();
    },
    pageCurriculumList(obj) {
      this.page.pageNum = obj.page;
      this.getTableList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.page.pageNum = 1;
      this.page.pageSize = obj.limit;
      this.getTableList();
    },
    // 获取列表
    getTableList() {
      // this.searchForm.startTime = this.time[0];
      // this.searchForm.endTime = this.time[1];
      this.listLoading = true;
      getCommissionSettlementsList({ ...this.searchForm, pageNum: this.page.pageNum, pageSize: this.page.pageSize }).then(res => {
        this.listLoading = false;
        if (res.data === null || res.data === '' || res.data === 'undefind') {
          this.settlementsList = [];
          this.page.total = 0;
        } else {
          this.settlementsList = res.data.list;
          this.page.total = res.data.total;
        }
      }).catch(err => {
        // this.$message({ type: 'warning', message: '暂无数据' });
        this.listLoading = false;
        console.log(err);
      });
    },
    // 打开详情页面
    openPaymentRecord(type, row) {
      this.getPaymentDetail(row.id);
      if (type === 'record') {
        this.dialogRecordVisible = true;
      } else {
        this.paymentForm.id = row.id;
        this.dialogPaymentVisible = true;
      }
    },
    getPaymentDetail(id) {
      getCommissionSettlementsDetail(id).then(res => {
        if (res.code === '0') {
          this.rowDetail = res.data;
          this.paymentForm.actualSettlementAmount = res.data.appliedSettlementAmount;
        }
      }).catch(() => {});
    },
    // 图片上传成功
    uploadSucessFn(val) {
      this.paymentForm.paymentPictureUrlSet.push(val.absolutePath);
    },
    removeImg(index) {
      this.paymentForm.paymentPictureUrlSet.splice(index, 1);
    },
    closeDialog() {
      this.dialogPaymentVisible = false;
      this.paymentForm = {
        id: '',
        actualSettlementAmount: '', // 结算金额
        paymentPictureUrlSet: [], // 打款凭证
        paymentRemark: '', // 备注
        status: 1
      };
      this.$refs.paymentForm.resetFields();
    },
    // 标记打款
    handlePayment() {
      if (this.paymentForm.paymentPictureUrlSet.length === 0) {
        this.$message.error('请上传打款凭证');
        return;
      }
      this.$refs['paymentForm'].validate((valid) => {
        if (valid) {
          this.ajaxLoading = true;
          markPayment(this.paymentForm).then((res) => {
            this.ajaxLoading = false;
            this.$notify.success({ title: 'Success', message: '操作成功', showClose: false, duration: 2000 });
            this.getTableList();
            this.closeDialog();
          }).catch(() => {
            this.ajaxLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 导出
    handleExportFilter() {
      var op = this.searchForm;
      window.location.href = exportCommissionSettlementsExcel(op) ? exportCommissionSettlementsExcel(op) : null;
    }
  }
};
</script>
<style lang="scss" scoped>
.table-box{
  padding: 0 30px;
}
.edit-form-input{
  width: 130px;
}
.info-box{
    display: flex;
    padding-left: 80px;
    line-height: 30px;
    margin-bottom: 20px;
}
.detail-box{
  padding: 0px 40px;
  line-height: 40px;
  .itemMarig{
    display: flex;
    flex-wrap: wrap;
    width: 85%;
  }
  .line-box{
    display: flex;
    justify-content: space-between;
  }
  .voucher-box{
    display: flex;
    align-items:top;
    span{
      width: 220px;
    }
    .imgBoxView{
      display: flex;
      flex-wrap: wrap;
      /deep/.el-image__inner{
        padding-bottom: 10px;
      }
    }
  }
}
.payment-form-input{
    width: 50%;
}
.picture-wrapper{
  display: flex;
  flex-wrap: wrap;

  .img{
    width: 90px;
    height: 90px;
    margin-right: 15px;
    margin-top: 15px;
  }
  .img-item{
    position: relative;
    .close-img{
      position: absolute;
      top :10px;
      right: 20px;
      cursor: pointer;
    }
  }

}
.up-box{
  /deep/.el-form-item__label:before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}

</style>
